<template>
  <div class="table-responsive">
    <table class="table table-sm mb-0">
      <thead>
        <tr>
          <th class="px-3">Region</th>
          <th class="px-3">MWh</th>
          <th class="px-3">Companies</th>
          <slot name="extra-headers"></slot>
          <th class="px-3">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(breakdown, region) in regionBreakdown" :key="region">
          <td class="px-3 align-middle">{{ region }}</td>
          <td class="px-3 align-middle">{{ breakdown.total_mwh }}</td>
          <td class="px-3 align-middle">{{ breakdown.company_count }}</td>
          <slot
            name="extra-columns"
            :region="region"
            :breakdown="breakdown"
          ></slot>
          <td class="px-3 text-nowrap">
            <button
              class="btn btn-sm btn-outline-secondary"
              @click="$emit('view-details', region)"
            >
              <font-awesome-icon icon="list" /> View Details
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  regionBreakdown: Record<string, any>;
}>();

defineEmits<{
  "view-details": [region: string];
}>();
</script>
